module.exports = __webpack_public_path__ + "img/png-5.7468da20.png";